import { useEffect } from 'react';
import { Form } from 'antd';
import { useGetManyWarehouses } from 'api/warehouses/use-get-many-warehouses';
import { useDistributionEfficiencyFiltersStore } from 'shared/stores/use-distribution-efficiency-filters';
import { disablePickerComparisonDate } from 'shared/utils/date-picker/disable-picker-comparison-dates';
import { transformAndSetFilters } from 'shared/utils/filters/transform-and-set-filters';
import { DataRangeFormPicker } from 'components/common/data-range-form-picker';
import { WarehouseFormSelect } from 'components/common/warehouse-form-select/warehouse-form-select';
import { StatisticsDateRangePicker } from 'components/statistics/statistics-date-range-picker';
import styles from './distribution-efficiency-filters.module.scss';

export const DistributionEfficiencyFilters = () => {
  const { filters, setFilters } = useDistributionEfficiencyFiltersStore();
  const [form] = Form.useForm();

  const mainPeriod = Form.useWatch('date', form);

  const { data: warehouses } = useGetManyWarehouses({ withDeprecated: false, internalOnly: true });

  const handleSuccess = () => {
    transformAndSetFilters(form, setFilters);
  };

  useEffect(() => {
    if (filters.warehouseId || !warehouses?.length) return;

    form.setFieldValue('warehouseId', warehouses[0].id);
    handleSuccess();
  }, [warehouses]);

  const handleMainPeriodChange = () => {
    form.setFieldValue('comparisonDate', null);
    handleSuccess();
  };

  const disabledComparisonDates = disablePickerComparisonDate(mainPeriod);

  return (
    <Form
      form={form}
      name='distribution-efficiency-filter'
      layout='horizontal'
      initialValues={filters}
      className={styles.form}>
      <WarehouseFormSelect
        name='warehouseId'
        label='Warehouse'
        placeholder='Warehouse'
        handleChange={handleSuccess}
        allowClear={false}
        withDeprecated={false}
        className={styles.warehouseSelect}
        internalOnly
      />
      <StatisticsDateRangePicker handleSuccess={handleMainPeriodChange} />
      {mainPeriod && (
        <DataRangeFormPicker
          name='comparisonDate'
          label='Comparison period'
          handleSuccess={handleSuccess}
          disabledDate={disabledComparisonDates}
        />
      )}
    </Form>
  );
};
